<template lang="pug">
div.item-img-uploader.f.fh
  div(v-if="imgURL && !isUploading").f.fh
    img(:src="imgURL").object-fit-cover
  v-progress-circular(v-else :size="24" width="3" indeterminate)
</template>

<style scoped lang="scss">
@import "@/scss/_variables.scss";

.item-img-uploader {
  img {
    max-width: 60%;
  }
}
</style>

<script>
import { storage } from '@/components/utils/firebase'
import { createNamespacedHelpers } from 'vuex'
const { mapState } = createNamespacedHelpers('auth')

export default {
  props: {
    file: {
      type: File,
      required: true
    },
    maxSize: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      imgURL: null,
      isUploading: false
    }
  },
  computed: {
    ...mapState(['uid'])
  },
  created () {
    this.uploadResizedImg()
  },
  methods: {
    async uploadResizedImg () {
      this.isUploading = true
      const base64 = await this.getBase64FromFile(this.file)
      const base64Resized = await this.resizeImage(base64)
      this.imgURL = await this.uploadImg(base64Resized)
      this.isUploading = false
    },
    async getBase64FromFile (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = (e) => reject(e)
      })
    },
    async resizeImage (base64image) {
      const image = await this.loadImage(base64image, 'Anonymous')

      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')

      const THUMBNAIL_WIDTH = this.maxSize.w
      const THUMBNAIL_HEIGHT = this.maxSize.h

      let width, height, ratio
      if (image.width > image.height) {
        // 横長の画像は横のサイズを指定値にあわせる
        ratio = image.height / image.width
        width = THUMBNAIL_WIDTH
        height = THUMBNAIL_WIDTH * ratio
      } else {
        // 縦長の画像は縦のサイズを指定値にあわせる
        ratio = image.width / image.height
        width = THUMBNAIL_HEIGHT * ratio
        height = THUMBNAIL_HEIGHT
      }
      canvas.setAttribute('width', width)
      canvas.setAttribute('height', height)

      ctx.clearRect(0, 0, width, height)
      ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height)

      return canvas.toDataURL()
    },
    async uploadImg (base64) {
      const fileId = this.getUniqueStr()
      const storageRef = storage.ref()
      const ref = storageRef.child(`USER/${this.uid}/ASSET/png/${fileId}`)
      const imgURL = await ref
        .putString(base64.split(',')[1], 'base64', {contentType: 'image/png'})
        .then(async (snapshot) => {
          return await snapshot.ref.getDownloadURL()
          .then(async downloadURL => downloadURL)
        })
      return imgURL
    }
  }
}
</script>